import { CampaignOverview } from "../../components/overview/CampaignOverview";
import * as OverviewContext from "../../contexts/OverviewContext";


export const Overview = () => {

    return (

        <OverviewContext.Provider>
            <CampaignOverview/>
        </OverviewContext.Provider>
    )
}